import { render, staticRenderFns } from "./WorkOrderForms.vue?vue&type=template&id=54faaea6&scoped=true"
import script from "./WorkOrderForms.vue?vue&type=script&lang=js"
export * from "./WorkOrderForms.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderForms.vue?vue&type=style&index=0&id=54faaea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54faaea6",
  null
  
)

export default component.exports